import ProductCard, { ProductCardProps } from "../../components/ProductCard";

export type { ProductCardProps };
export default ProductCard;

